import React, { useContext, useEffect, useState } from 'react'
import logo from '../../assets/new logo.png';
import {Link, useNavigate} from 'react-router-dom'

import {useCookies} from 'react-cookie';
import modalContext from '../../context/ModalContext';

function Navigation() {
  const navigate = useNavigate();
  const [cookie, setCookie] = useCookies(["token"]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const {modal, setModal} = useContext(modalContext);

  useEffect(()=>{
    if(cookie.token){
      setIsLoggedIn(true);
    }
  },[]);

  return (
    <div style={{backgroundColor: '#462054'}} className='w-full flex h-full'>
      <div className='h-full w-1/4 flex mx-[0.5vmax] justify-start items-center'>
        <Link to='/loggedinhome'><img className='w-[10vmax] rounded-[0.5vmax]' src={logo} /></Link>
      </div>
      <div className='flex text-[1.3vmax] font-semibold w-3/4 h-full justify-end items-center gap-[3vmax] mx-[2vmax]'>
      <Link to='/loggedinhome'><div className='text-white p-[0.3vmax] cursor-pointer nav-btns'>HOME</div></Link>
      <Link to='/aboutus'><div className='text-white p-[0.3vmax] cursor-pointer nav-btns'>ABOUT</div></Link>
      {isLoggedIn && <Link to='/saved'><div className='text-white p-[0.3vmax] cursor-pointer nav-btns'>SAVED USERS</div></Link>}
      {isLoggedIn && <div onClick={(e)=>{
        setModal(true);
      }} className='text-white p-[0.3vmax] cursor-pointer nav-btns'>PROFILE</div>}
      <Link to={isLoggedIn? '/logout' : '/login'}><div style={{backgroundColor: '#F8F8FF'}} className='nav-btns text-black p-[0.5vmax] rounded-[0.5vmax] font-bold cursor-pointer'>{cookie.token ? "LOGOUT" : "LOGIN"}</div></Link>
      </div>
    </div>
  )
}

export default Navigation